<template>
  <div class="simple-landing-logo">
    <div class="simple-landing-logo__kaia" />
    <img
      v-if="corporate?.logoFile"
      :src="corporate.logoFile"
      :alt="corporate.title"
      class="simple-landing-logo__corporate"
    />
    <span
      v-else-if="corporate?.title"
      class="simple-landing-logo__corporate"
    >
      {{ corporate.title }}
    </span>
  </div>
</template>

<script setup>
import Corporate from '@shared/data/models/corporate.js'

defineProps({
  corporate: {
    type: Corporate,
    default: null,
  },
})
</script>

<style lang="scss">
.simple-landing-logo {
  background-color: transparent;
  width: 100%;
  @include flex-container(row, space-between, md, center);

  @include media-up(md) {
    @include flex-container(row, flex-start, md, center);
  }

  &__kaia {
    background-image: url('@shared/assets/img/kaia_text_logo.svg');
    background-position: left;
    background-repeat: no-repeat;
    background-size: contain;
    height: 15px;
    width: 100px;

    @include media-up(md) {
      background-image: url('@shared/assets/img/kaia_img_logo.svg');
      height: 80px;
      width: 80px;
    }
  }

  &__corporate {
    max-height: 64px;
    max-width: 200px;

    @include media-up(md) {
      max-height: 80px;
      max-width: 272px;
    }
  }
}
</style>
